import type { ReportRangeKey } from '@/lib/report-range';

/**
 * SORGU ANAHTARI FABRIKASI — isletme raporlari.
 *
 * ARALIK ANAHTARIN PARCASI: aksi halde 30 gunden 90 gune gecildiginde
 * TanStack ayni anahtari gorur ve 30 gunluk rakamlari yeni etiketin altinda
 * gosterir. Rapor ekranlarinda bu, hatasi gorulemeyen bir hata.
 *
 * `all` koku bilincli: `invalidateQueries({ queryKey: reportKeys.all })` tek
 * satirda uc ucun her araligini tazeler ve yeni bir rapor eklendiginde
 * unutulmaz.
 */
export const reportKeys = {
  all: ['reports'] as const,

  /** GET /v1/reports/offers-summary */
  offersSummary: (range: ReportRangeKey) => [...reportKeys.all, 'offers-summary', range] as const,

  /**
   * Ayni uc, ONCEKI donem penceresi icin. Ayri bir anahtar SART: ayni anahtarla
   * cagrilsaydi iki sorgu birbirinin onbellegini ezerdi.
   */
  offersSummaryPrevious: (range: ReportRangeKey) =>
    [...reportKeys.all, 'offers-summary', 'previous', range] as const,

  /** GET /v1/reports/tasks-summary */
  tasksSummary: (range: ReportRangeKey) => [...reportKeys.all, 'tasks-summary', range] as const,

  /** GET /v1/reports/member-activity — YALNIZ org yoneticisi icin calisir. */
  memberActivity: (range: ReportRangeKey) =>
    [...reportKeys.all, 'member-activity', range] as const,

  /**
   * GET /v1/reports/warned-tasks — odeme uyarisi alan islemler (sayfalanir).
   *
   * SIRALAMA ANAHTARIN PARCASI: aralikla ayni gerekce. Siralama degistiginde satir KUMESI de
   * degisir (ilk yirmi satir baskadir), yani ayni anahtar altinda tutmak eski sayfalari yeni
   * siralamanin devami sanip birlestirirdi.
   */
  warnedTasks: (range: ReportRangeKey, sort: string) =>
    [...reportKeys.all, 'warned-tasks', range, sort] as const,

  /** GET /v1/reports/decision-time — ortalama karar suresi. */
  decisionTime: (range: ReportRangeKey) => [...reportKeys.all, 'decision-time', range] as const,
};
